import { inject, Pipe, PipeTransform } from '@angular/core';
import { UnitSystemType } from '@data-access';
import { UnitCategory } from '../utils/unit-conversion.utils';
import { UnitSystemService } from '../services/unit-system.service';

/**
 * Converts a value stored in the imperial base unit (mi / in / lb) into the
 * active unit system. Returns an unformatted number — combine with 'number'.
 */
@Pipe({ name: 'unitValueConvert', standalone: true })
export class UnitValueConvertPipe implements PipeTransform {
  private service = inject(UnitSystemService);

  transform(
    value: number | null | undefined,
    category: UnitCategory,
    unitSystem?: UnitSystemType | null,
  ): number | null {
    return this.service.convertValueFromBase(value, category, unitSystem);
  }
}
